import axios from "axios";

export const SET_TEAMCONSISTENCY_DATA = "set_teamconsistency_data";
export const SET_TEAMCONSISTENCY_INITIALDATA = "set_teamconsistency_initialdata";
export const SET_TEAMCONSISTENCY_CHARTREGISTERED = "set_teamconsistency_chartregistered";

const ROOT_URL = "https://www.roadtonationals.com/api/men";

export function getTeamConsistencyData(config) {
  const request = axios.get(`${ROOT_URL}/teamconsistency/${config.year}/${config.team}`);
  return (dispatch) => {
      dispatch({type: SET_TEAMCONSISTENCY_CHARTREGISTERED, payload: false});
    request.then(response => {
      dispatch({type: SET_TEAMCONSISTENCY_DATA, payload: response.data});
    })
    .catch(error => {
      throw(error);
    });
  };
}

export function setTeamConsistencyInitialData(val) {
  return {
    type: SET_TEAMCONSISTENCY_INITIALDATA,
    payload: val
  };
}
